import EL, { HTMLELEMENT } from '../../EL/EL.js';
import TEXTBLOCK from '../../DOM/div/TEXTBLOCK/TEXTBLOCK.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeStruct } from '../../../enums/MODELS.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
import HEADING from '../../DOM/heading/HEADING.js';
import UL from '../../DOM/LIST/ul/UL.js';
import OL from '../../DOM/LIST/ol/OL.js';
import DL from '../../DOM/LIST/dl/DL.js';
// Model Structure
export const divAttr = makeAttrStruct([
    ['class'],
    ['name']
]);
export const divData = makeDataStruct([]);
export const divModel = makeStruct([
    ['attributes', divAttr],
    ['data', divData]
]);
// Simplified Model
export function div(className, name) {
    return {
        attributes: divAttr(className, name),
        data: divData()
    };
}
export default class DIV extends EL {
    constructor(node, model) {
        super(node, HTMLELEMENT.DIV, model);
    }
    addHeading(model) {
        return this.addChild(new HEADING(this, model));
    }
    addDiv(model) {
        return this.addChild(new DIV(this, model));
    }
    addTextblock(model) {
        return this.addChild(new TEXTBLOCK(this, model));
    }
    addUL(model) {
        return this.addChild(new UL(this, model));
    }
    addOL(model) {
        return this.addChild(new OL(this, model));
    }
    addDL(model) {
        return this.addChild(new DL(this, model));
    }
}
export { EL, HTMLELEMENT };
